import { render, staticRenderFns } from "./new-marketplace-item.vue?vue&type=template&id=0b052d2b&"
import script from "./new-marketplace-item.vue?vue&type=script&lang=js&"
export * from "./new-marketplace-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports